import React, { useState } from 'react';

const TerritoryStep = ({ data, onChange }) => {
  const [newArea, setNewArea] = useState('');

  const handleChange = (field, value) => {
    onChange({
      ...data,
      [field]: value,
    });
  };

  const addCoverageArea = () => {
    if (newArea.trim()) {
      const updatedAreas = [...(data.coverageAreas || []), newArea.trim()];
      onChange({
        ...data,
        coverageAreas: updatedAreas,
      });
      setNewArea('');
    }
  };

  const removeArea = (index) => {
    const updatedAreas = data.coverageAreas.filter((_, i) => i !== index);
    onChange({
      ...data,
      coverageAreas: updatedAreas,
    });
  };

  const togglePropertyType = (type) => {
    const currentTypes = data.propertyTypes || [];
    const updatedTypes = currentTypes.includes(type)
      ? currentTypes.filter(t => t !== type)
      : [...currentTypes, type];
    
    onChange({
      ...data,
      propertyTypes: updatedTypes,
    });
  };

  return (
    <div className="onboarding-step">
      <div className="step-header">
        <h2>Territory & Coverage</h2>
        <p>Define your franchise territory and areas of operation</p>
      </div>

      <div className="form-grid">
        <div className="form-group full-width">
          <label>Primary City *</label>
          <input
            type="text"
            value={data.primaryCity || ''}
            onChange={(e) => handleChange('primaryCity', e.target.value)}
            placeholder="e.g., Mumbai, Delhi, Bangalore"
            required
          />
          <small>Main city where your franchise will operate</small>
        </div>

        <div className="form-group full-width">
          <label>Coverage Areas</label>
          <div className="area-input-group">
            <input
              type="text"
              value={newArea}
              onChange={(e) => setNewArea(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addCoverageArea())}
              placeholder="e.g., Andheri, Bandra, Juhu"
            />
            <button
              type="button"
              className="btn-add-area"
              onClick={addCoverageArea}
              disabled={!newArea.trim()}
            >
              + Add Area
            </button>
          </div>
          <small>Specific neighborhoods or localities you will cover</small>
        </div>

        {data.coverageAreas && data.coverageAreas.length > 0 && (
          <div className="form-group full-width">
            <div className="areas-list">
              {data.coverageAreas.map((area, index) => (
                <div key={index} className="area-tag">
                  <span>{area}</span>
                  <button
                    type="button"
                    onClick={() => removeArea(index)}
                    className="remove-tag"
                    title="Remove area"
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="form-group full-width">
          <label>Property Types *</label>
          <div className="property-types-grid">
            <label className="checkbox-card">
              <input
                type="checkbox"
                checked={(data.propertyTypes || []).includes('residential')}
                onChange={() => togglePropertyType('residential')}
              />
              <div className="checkbox-content">
                <div className="checkbox-icon">🏠</div>
                <div className="checkbox-label">
                  <strong>Residential</strong>
                  <small>Apartments, Houses, Villas</small>
                </div>
              </div>
            </label>

            <label className="checkbox-card">
              <input
                type="checkbox"
                checked={(data.propertyTypes || []).includes('commercial')}
                onChange={() => togglePropertyType('commercial')}
              />
              <div className="checkbox-content">
                <div className="checkbox-icon">🏢</div>
                <div className="checkbox-label">
                  <strong>Commercial</strong>
                  <small>Offices, Retail, Warehouses</small>
                </div>
              </div>
            </label>

            <label className="checkbox-card">
              <input
                type="checkbox"
                checked={(data.propertyTypes || []).includes('land')}
                onChange={() => togglePropertyType('land')}
              />
              <div className="checkbox-content">
                <div className="checkbox-icon">🌳</div>
                <div className="checkbox-label">
                  <strong>Land/Plots</strong>
                  <small>Vacant land, Farm land</small>
                </div>
              </div>
            </label>

            <label className="checkbox-card">
              <input
                type="checkbox"
                checked={(data.propertyTypes || []).includes('luxury')}
                onChange={() => togglePropertyType('luxury')}
              />
              <div className="checkbox-content">
                <div className="checkbox-icon">💎</div>
                <div className="checkbox-label">
                  <strong>Luxury</strong>
                  <small>Premium & High-end properties</small>
                </div>
              </div>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TerritoryStep;

